import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";


import { handleVerifyTransaction } from "../../shared/controllers/transactionController";

import green from "./assets/green.svg";

const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error && error.message) {
        return error.message;
    }

    if (
        typeof error === "object" &&
        error !== null &&
        typeof (error as { message?: unknown }).message === "string"
    ) {
        return (error as { message: string }).message;
    }

    return "There was an error verifying your payment. Please try again.";
};

const PaymentSuccessful: React.FC = () => {
    const [isChecking, setIsChecking] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const location = useLocation();

    // Extract session_id from URL
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get("session_id");

    // Verify transaction
    useEffect(() => {
        if (sessionId) {
            const userData = {
                session_id: sessionId,
            };

            const verify = async () => {
                try {
                    await handleVerifyTransaction(userData);
                    setIsSuccess(true);
                    setIsChecking(false);
                } catch (error: unknown) {
                    setErrorMessage(getErrorMessage(error));
                    setIsChecking(false);
                }
            };
            verify();
        } else {
            setErrorMessage("Missing session information. Please try again.");
            setIsChecking(false);
        }
    }, [sessionId]);

    return (
        <div
            className="w-full flex items-center justify-center"
            role="alert"
            aria-live="assertive"
        >
            <div className="px-4 max-w-[600px] flex flex-col w-full justify-center h-svh items-center">
                {isChecking ? (
                    <>
                        <p className="text-xl font-Manrope font-semibold text-black mt-3 text-center">
                            Checking Transaction...
                        </p>
                        <p className="mt-3 max-w-[400px] text-center font-Manrope font-normal text-base text-black">
                            We're verifying your payment, please wait a moment.
                        </p>
                    </>
                ) : isSuccess ? (
                    <>
                        <img src={green} alt="Success" />
                        <p className="text-xl font-Manrope font-semibold text-black mt-3 text-center">
                            Payment Received! You're All Set!
                        </p>
                        <p className="mt-3 max-w-[400px] text-center font-Manrope font-normal text-base text-black">
                            Your payment has been processed. Get ready for the fun to begin!
                        </p>
                        <Link
                            to="/dashboard"
                            className="bg-[#317333] rounded-md py-3 mt-4 px-4 font-Manrope text-[#fff] font-semibold text-base flex justify-center items-center"
                        >
                            Return to Dashboard
                        </Link>
                    </>
                ) : (
                    <>
                        <p className="text-xl font-Manrope font-semibold text-black mt-3 text-center">
                            Payment Failed
                        </p>
                        <p className="mt-3 max-w-[400px] text-center font-Manrope font-normal text-base text-black">
                            {errorMessage}
                        </p>
                        <Link
                            to="/dashboard"
                            className="bg-[#D9534F] rounded-md py-3 mt-4 px-4 font-Manrope text-[#fff] font-semibold text-base flex justify-center items-center"
                        >
                            Return to Dashboard
                        </Link>
                        <Link
                            to="/plans"
                            className="bg-[#317333] rounded-md py-3 mt-2 px-4 font-Manrope text-[#fff] font-semibold text-base flex justify-center items-center"
                        >
                            Try Again
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccessful;
